import { render, staticRenderFns } from "./sales_apply.vue?vue&type=template&id=18492380&scoped=true"
import script from "./sales_apply.vue?vue&type=script&lang=js"
export * from "./sales_apply.vue?vue&type=script&lang=js"
import style0 from "./sales_apply.vue?vue&type=style&index=0&id=18492380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18492380",
  null
  
)

export default component.exports